// All API calls and session cookies must originate on the configured app origin.
// This is browser navigation, not an HTTP 308 or a CORS/auth bypass.
export const canonicalDestination = (currentHref, backendUrl) => {
  const backend = new URL(backendUrl);
  if (!["https:", "http:"].includes(backend.protocol) || backend.username || backend.password) {
    throw new Error("Invalid configured application origin");
  }
  const current = new URL(currentHref), target = new URL(backend.origin);
  if (current.origin === target.origin) return null;
  // Assign components separately: a //host-like path cannot replace the authority.
  target.pathname = current.pathname;
  target.search = current.search;
  target.hash = current.hash;
  return target.href;
};